
import Headroom from "../headroom.js";
import Splide from "../splide.min.js";

// Header
const myElement = document.querySelector("#header");
const headroom = new Headroom(myElement);

headroom.init();

// Splide

new Splide('.splide', {
    type: 'slide',
    perPage: 4,
    gap: '2rem', // Ajoutez un espace de 10% entre les diapositives
    pagination: false,
    arrows: true,
    cover: true,

    drag: false,

    arrowPath: 'M1.5002 1.93199L0.200195 3.31199L7.4502 10.612L14.7002 17.912L7.4502 25.162L0.200195 32.412L2.5002 34.812L15.1002 22.212L19.5002 17.912L15.1002 13.512L2.5002 0.911987L1.5002 1.93199Z',

    // rewind: true, // Permet de revenir à la première diapositive après la dernière
    classes: {
        arrow: 'splide__arrow custom-arrow',
        prev: 'splide__arrow--prev custom-prev',
        next: 'splide__arrow--next custom-next',
        slide: 'custom-slide' // Classe pour styliser les diapositives spéciales
    },

    breakpoints: {
        1023: {
            type: 'loop',
            drag: true,
            perPage: 1,
            gap: '0',
            fixedWidth: '100%',
            fixedHeight: 'auto',
        }
    }
}).mount();

// Splide

new Splide('.splide2', {
    type: 'loop',
    perPage: 4,
    gap: '2rem', // Ajoutez un espace de 10% entre les diapositives
    pagination: false,
    arrows: true,
    cover: true,

    arrowPath: 'M1.5002 1.93199L0.200195 3.31199L7.4502 10.612L14.7002 17.912L7.4502 25.162L0.200195 32.412L2.5002 34.812L15.1002 22.212L19.5002 17.912L15.1002 13.512L2.5002 0.911987L1.5002 1.93199Z',

    // rewind: true, // Permet de revenir à la première diapositive après la dernière
    classes: {
        arrow: 'splide__arrow custom-arrow',
        prev: 'splide__arrow--prev custom-prev',
        next: 'splide__arrow--next custom-next',
        slide: 'custom-slide' // Classe pour styliser les diapositives spéciales
    },

    breakpoints: {
        1023: {
            perPage: 1,
            gap: '1rem',
            fixedWidth: '100%',
            fixedHeight: 'auto',
        }
    }
}).mount();

new Splide('.maillot-rouge-splide', {
    type: 'slide',
    perPage: 4,
    gap: '2rem', // Ajoutez un espace de 10% entre les diapositives
    pagination: false,
    arrows: true,
    cover: true,

    drag: false,

    arrowPath: 'M1.5002 1.93199L0.200195 3.31199L7.4502 10.612L14.7002 17.912L7.4502 25.162L0.200195 32.412L2.5002 34.812L15.1002 22.212L19.5002 17.912L15.1002 13.512L2.5002 0.911987L1.5002 1.93199Z',

    // rewind: true, // Permet de revenir à la première diapositive après la dernière
    classes: {
        arrow: 'splide__arrow custom-arrow',
        prev: 'splide__arrow--prev custom-prev',
        next: 'splide__arrow--next custom-next',
        slide: 'custom-slide' // Classe pour styliser les diapositives spéciales
    },

    breakpoints: {
        1023: {
            type: 'loop',
            drag: true,
            perPage: 1,
            gap: '0',
            fixedWidth: '100%',
            fixedHeight: 'auto',
        }
    }
}).mount();